import React from 'react'
import { Modal } from 'react-bootstrap'
import { ConsentAvatar } from './ConsentAvatar'
import { ConsentStateDropdown } from './ConsentStateDropdown'
import { ConsentFormBody } from './ConsentFormBody'
import { UserConsentState } from './model'
import { EvidenceUploadConfig, CommentUploadConfig } from '../../models/Account'

type ConsentConfirmationModalProps = {
  show: boolean
  onCancel: () => void
  contactName: string
  consentState: UserConsentState
  onConsentStateChange: (state: UserConsentState) => void
  evidenceUploadConfig: EvidenceUploadConfig
  commentUploadConfig: CommentUploadConfig
  onSave: (params: { reason?: string; attachmentFileId?: string }) => void
  isLoading: boolean
}

export const ConsentConfirmationModal: React.FC<ConsentConfirmationModalProps> = ({
  show,
  onCancel,
  contactName,
  consentState,
  onConsentStateChange,
  evidenceUploadConfig,
  commentUploadConfig,
  onSave,
  isLoading,
}) => (
  <Modal show={show} onHide={onCancel} size='xl' centered>
    <Modal.Header closeButton className='px-4 pt-4 pb-3 border-0'>
      <Modal.Title className='heading-sm'>Consent tracking status</Modal.Title>
    </Modal.Header>
    <Modal.Body className='px-4 pb-5 pt-3'>
      <div className='border rounded-2 p-3 d-flex flex-column gap-4'>
        <div className='d-flex align-items-center justify-content-between'>
          <div className='d-flex align-items-center gap-2'>
            <ConsentAvatar name={contactName} consentState={consentState} />
            <span className='fw-bold paragraph-medium zocks-text-gray-900'>{contactName}</span>
          </div>
          <ConsentStateDropdown value={consentState} onChange={onConsentStateChange} />
        </div>

        <ConsentFormBody
          evidenceUploadConfig={evidenceUploadConfig}
          commentUploadConfig={commentUploadConfig}
          onSave={onSave}
          onCancel={onCancel}
          isLoading={isLoading}
        />
      </div>
    </Modal.Body>
  </Modal>
)
